<script>
    import { onDestroy } from "svelte";
    import { format } from "api/formatter";
    import { stopMusic, playMusic } from "../modules/music";
    import { getName } from "../modules/animationsName";
    import { buyAnimation, playAnimation, setFavourite } from "../modules/functions";
    import { purchasedAnimations, favouriteAnimations, draggingAnim } from "store/animationsMenu";
    import animationsConfig from "../json/animations.json";
    
    export let animationData;
    export let animationKey;
    export let currentCategory;

    let currentTime = 0,
        duration = 0,
        isHovered = false;

    $: {
        currentTime = 0;
        duration = 0;   
        
        stopMusic();
    }

    const onMouseEnter = (event) => {
        isHovered = true;
        playMusic(animationData);
    }

    const onMouseLeave = (event) => {
        isHovered = false;
        stopMusic();
    }

    const onClick = (e) => {
        if (e.target.className.includes("favourite-button"))
            return;
        
        if (animationData.Price > 0 && !$purchasedAnimations.includes(animationKey)) {
            buyAnimation(animationKey);
        }
        else {
            playAnimation(animationKey);
        }
    }

    onDestroy(() => {
        stopMusic();
        isHovered = false;
    });
</script>

<button on:click={(e) => onClick(e)} on:mouseenter={onMouseEnter} on:mouseleave={onMouseLeave}
    draggable={true} on:dragstart={() => draggingAnim.set(animationKey)} on:dragend={() => draggingAnim.set(null)}
    class="animations-block">
    <div class="picture">
        {#if isHovered} 
            <video class="animations__element_img" 
                src={ `${animationsConfig.picture_url}/${animationData.Dictionary}^${animationData.Name}.webm` }
                loop={true}
                autoplay={true}
                name="media"
                volume={0}
                bind:currentTime={currentTime}
                bind:duration={duration}>
                <track kind="captions">
            </video>
        {/if}
        {#if !isHovered}
            <img src={ `${animationsConfig.picture_url}/${animationData.Dictionary}^${animationData.Name}.png` } alt="" loading="lazy" />
        {/if}
    </div>

    {#if currentCategory != "shop"}
        <button on:click={() => setFavourite(animationKey)} class:active={$favouriteAnimations.includes(animationKey)} class="favourite-button">
            <svg xmlns="http://www.w3.org/2000/svg" width="1.2962962962962963vh" height="1.2052777777777777vh" viewBox="0 0 14 13.017" > <path id="like-svgrepo-com" d="M13.977,4.443A3.968,3.968,0,0,0,10.188.562,3.766,3.766,0,0,0,6.961,2.421,3.63,3.63,0,0,0,3.812.562,3.968,3.968,0,0,0,.023,4.443,4,4,0,0,0,.142,5.918,6.326,6.326,0,0,0,2.081,9.153l4.877,4.426,4.961-4.426a6.327,6.327,0,0,0,1.938-3.235A4.011,4.011,0,0,0,13.977,4.443Z" transform="translate(0 -0.562)" fill="#101010" ></path> </svg>
        </button>
    {/if}

    {#if animationData.Price > 0 && !["favourites", 6].includes(currentCategory) }
        <div class="price-data">
            { format("money", animationData.Price) }
            <img src="https://cdn.just-rp.online/cdn-ra3.ragemp.pro/cloud/jc.png" alt="">
        </div>
    {/if}

    <div class="title-data">
        { getName(animationKey) }
    </div>
</button>